export function CMExcel(XLSX, data) {
    var wb = XLSX.utils.book_new();

    // Header
    var ws = XLSX.utils.json_to_sheet([{}], { header: [], skipHeader: true });

    XLSX.utils.sheet_add_json(ws, [
        { A: "", B: "", C: "", D: "", E: "", F: "REPUBLIC OF THE PHILIPPINES", },
        { A: "", B: "", C: "", D: "", E: "", F: "COASTING MANIFEST", },
        { A: "" },
        { A: "", B: "FORM NO. 72" },
        { A: "" },
        { A: "", B: "MANIFEST OF THE whole cargo laden on board the__________________________class coasting vessel ___________________________________" },
        { A: "", B: "License No. ___________________Licensed _____________________propelled by ______________________Voyage no.______" },
        { A: "", B: "Whereof is ____________________burden ___________ Tons _______ crew board from _______________________________" },
        { A: "" },
        { A: "", B: "for_______________________" },
        { A: "", B: "   (here give port of call)" },
        { A: "" },
    ], { header: [], skipHeader: true });

    XLSX.utils.sheet_add_json(ws, [
        {
            A: "", B: "WAYBILL", C: "No. of Packages", D: "Cubic Meter",
            E: "Kind of Parcel", F: "Weight in Tons", G: "Value", H: "Shipper",
            I: "Consignee", J: "Address",
            // K: "CONTAINER #", L: "CARGO TYPE"
        }
    ], { header: [], skipHeader: true, origin: -1 });
    if (data) {
        var detail = data.details;
        detail.forEach((d, id) => {
            XLSX.utils.sheet_add_json(ws, [
                {
                    A: id + 1, B: d.wayBillRef, C: d.quantiyTeu, D: d.cargoVolume + "cbm",
                    E: d.goods, F: d.cargoWeight, G: d.declaredValue, H: d.shipper,
                    I: d.consignee, J: d.consigneeAddress,
                    // K: d.vanNumber, L: d.cargoType
                }
            ], { header: [], skipHeader: true, origin: -1 });
        });
    }

    var wscols = [
        { wch: 4 },  // Count
        { wch: 15 }, // Waybill
        { wch: 12 }, // No of Package
        { wch: 10 }, // Cubic Meter
        { wch: 25 }, // Kind of Parcel or Goods
        { wch: 12 }, // Weight in Tons
        { wch: 13 }, // Declared Value
        { wch: 25 }, // Shipper
        { wch: 25 }, // Consignee
        { wch: 25 }, // Address
        // { wch: 12 }, // Container
        // { wch: 10 }, // Cargo Type
    ];

    ws['!cols'] = wscols;

    XLSX.utils.sheet_add_json(ws, [
        { A: "" },
        { A: "", B: "", C: "", D: "Empowered to Administer Oath" },
        { A: "", B: "", C: "", D: "under the provision of Section 81 Act. No. 355" },
        { A: "" },
        { A: "" },
        { A: "", B: "The Master of _____________________, having taken the described oath to the manifest of" },
        { A: "", B: "the herewith mentioned  _______________cargo and delivered in duplicate thereof to this office." },
        { A: "", B: "permission is hereby granted to the said vessel to proceed to the port or ports named within." },
        { A: "" },
        { A: "" },
        { A: "", B: "This clause to be submitted when vessel with passenger." }
    ], { header: [], skipHeader: true, origin: -1 });

    XLSX.utils.book_append_sheet(wb, ws, "Coasting Manifest");

    XLSX.writeFile(wb, "Coasting_Manifest.xlsx")
}